<template>
	<div v-if="isFinish" class="index">
		<el-container class="container">
			<el-aside v-if="showAside" class="aside" :width="showMenu ? '146px' : '69px'">
				<section class="logo-box">
					<w-image class="show-img" :src="headImg" v-if="headImg" type="head"></w-image>
					<img class="show-img" src="~/images/img/head-logo.png" v-else>
					<span class="logo-text" v-if="showMenu" @click="stoptimer">极速订2.0</span>
				</section>
				<!-- {{platFormName}} -->
				<MainMenu class="main-menu-style" :activeIndex.sync="activeIndex" :showMenu="showMenu" @getMessage="getMessage"></MainMenu>
			</el-aside>
			<el-container class="right-container">
				<el-header class="header">
					<div v-if="showAside" class="title-box">
						<img v-if='showMenu' @click="changeShowMenu" class="fold-img" src="~/images/icon/retract.png" alt="">
						<img v-else @click="changeShowMenu" class="fold-img" src="~/images/icon/open.png" alt="">
					</div>
					<div class="system-message">
						<marquee behavior="scroll" direction="left" scrollamount="4" style="width: 600px;"><span class="item-msg" v-for='(item, index) in msgList' :key="index" @click="goDetail(item)">{{item.msg}}</span></marquee >
					</div>
					<div class="menu-btn" style="justify-content: flex-end;">
						<div class="person-box">
							<div class="shop-box">
								{{shopName}}<i class="el-icon-arrow-down el-icon--right"></i>
								<el-select v-model="shopNameId" size="mini" class="shop-pull-box" @change="shopChange">
									<el-option
									v-for="item in shopList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
									</el-option>
								</el-select>
							</div>
							<el-dropdown v-if="showAside" trigger="click" @command="handleCommand" style="margin-left:20px">
								<span class="el-dropdown-link">
									{{name}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="editPwd">修改密码</el-dropdown-item>
									<el-dropdown-item command="exit">退出登录</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</el-header>
				<router-view class="content"></router-view>
				<div class="msgTip">
					<el-popover
						placement="left-end"
						popper-class="tool-class"
						width="200"
						trigger="hover">
						<div class="tool-content">
							<div @click="handleCommand1('helpCenter')">
								<img src="~/images/icon/bangzhu1.png" />帮助中心
							</div>
							<div @click="handleCommand1('showMini')">
								<img src="~/images/icon/saomiaoerweima1.png" />扫码关注卖家小程序
							</div>
							<div @click="handleCommand1('dowmloadFile')">
								<img src="~/images/icon/gongzuoshoucefenleiguanli.png" />后台管理手册
							</div>
							<div @click="handleCommand1('dowmloadCopyFile')">
								<img src="~/images/icon/dayin.png" />打印工具下载
							</div>
						</div>
						<img slot="reference" src="~/images/icon/help-tool.png" class="tool-img">
					</el-popover>
					<img src="~/images/icon/msg-box-icon.png" style="width: 50px;height: 50px;" @click="msgClick">
					<div v-if="newMsgNum>0 && !showMsg" class="new-msg-num">{{AuthorityList['12_0001_0000_00'] ? newMsgNum : 0}}</div>
				</div>
				<div class="msg-box" v-show="showMsg">
					<div class="msg-box-title">
						<div>新消息({{AuthorityList['12_0001_0000_00'] ? newMsgNum : 0}})</div>
						<div @click="msgClick" style="width: 10px;height: 10px;cursor: pointer;line-height: 10px;">x</div>
					</div>
					<div class="msg-box-body" ref='msgBox'>
						<div v-for="(item,index) in msgList1" :key='index' class="msg">
							<div class="msg-title" @click='goOrder(item)' >
								<div :class="!item.readflag ? 'new-flage':''">{{item.title}}</div>
								<div style="color: #595959;">{{item.time}}</div>
							</div>
							<div @click='goOrder(item)' class="msg-body">商品总额：￥{{item.totalmoney}}，品项：{{item.itemcount}}种，数量{{item.itemquantity}}</div>
							<div @click='goOrder(item)' class="msg-body">{{item.customerName}}/{{item.customerCategoryName}}</div>
							<div class="msg-btn-box">
								<el-button @click='goOrder(item)' type="primary" size="mini">去看看</el-button>
								<el-button @click='readMsg1(item)' v-if="!item.readflag" size="mini">标记为已读</el-button>
							</div>
						</div>
					</div>
					<div class="msg-box-footer" @click="readAllMsg">全部标记已读</div>
				</div>
			</el-container>
		</el-container>
		<el-dialog class="detail-dialog-title" title="修改密码" top='60px' :before-close='closeEdit' :visible.sync="editePwdShow" width='500px' :close-on-click-modal="false">
			<editPwd :editShow='editePwdShow' v-if="editePwdShow" @cancel='closeEdit'/>
		</el-dialog>
		<el-dialog :title="'系统通知'" :before-close="cancelMsgDialog" class="dialog-title notice" :visible.sync="showMsgDialog" width='600px' height='300px' :close-on-click-modal="false">
			<div class="msg-info">
				{{message}}
			</div>
			<el-button type="primary" size="medium" @click="haveRead">确认已读</el-button>
		</el-dialog>
		<el-dialog class="miniDialog" :visible.sync="showMini" width='360px' height='400px' :close-on-click-modal="false">
			<div style="width: 360px;display: flex;align-items: center;justify-content: center;flex-direction: column;">
				<div class="mini-img-box">
					<img src="~/images/icon/mini-img.jpg" />
				</div>
				<div class="white-line"></div>
				<div>
					<i @click="closeMini" class="el-icon-error" style="font-size: 26px;color: #fff;"></i>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import MainMenu from '@/components/MainMenu.vue'
import editPwd from '@/components/personnel/editPwd.vue'
const FORM_LABEL_WIDTH = '120px'
export default {
	name: 'Index',
	components: {
		MainMenu,
		editPwd
	},
	data () {
		return {
			isFinish: false,
			showMini: false,
			hasMoreMsg: true,
			newMsgNum: 0,
			isLoad: false,
			msgList1: [],
			showMsg: false,
			timer: null,
			time: 10000,
			timer2: null,
			guardtimer: null,
			time2: 10000,
			remindFlag: true,
			showMenu: true,
			activeIndex: '1',
			dialogFormVisible: false,
			formLabelWidth: FORM_LABEL_WIDTH,
			username: '',
			form: {
				name: '',
				password: '',
				repassword: ''
			},
			headImg: '',
			name: '',
			tel: '',
			editePwdShow: false,
			shopOptions: [],
			msgList: [],
			animate: false,
			showMsgDialog: false,
			start: 0,
			total: 0,
			loading: false,
			message: '',
			readMsgId: '',
			firstId: '',
			lastId: '',
			orderParams: {},
			AuthorityList: {
				'07_0000_0000_00': false,
				'07_0001_0000_00': false,
				'07_0001_0001_00': false,
				'07_0001_0004_00': false,
				'07_0001_0007_00': false,
				'07_0001_0010_00': false,
				'07_0002_0000_00': false,
				'07_0002_0001_00': false,
				'12_0001_0000_00': false
			},
			shopList: [],
			shopName: '',
			shopNameId: '',
			showAside: true
		}
	},
	created () {
		this.initPage().then(() => {
			this.init()
		})
	},
	mounted () {
		this.$refs.msgBox.addEventListener('scroll', this.onScroll)
		if ((location.hash.indexOf('?') !== -1) && (location.hash.indexOf('session') !== -1)) {
			let session = location.hash.split('?')[1].split('=')[1]
			window.sessionStorage.setItem('shiroSession', session)
		}
	},
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		})
	},
	methods: {
		initPage () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestGet', {
					url: `${this.$fxBaseApi.urlNV}/account/islogin`,
					loading: false
				}).then(res => {
					if (res) {
						this.isFinish = true
						resolve()
					} else {
						this.$message.error('登录已过期，请重新登录')
						this.$router.push('/login')
					}
				}).catch(() => {
					this.$message.error('登录已过期，请重新登录')
					this.$router.push('/login')
				})
			})
		},
		init () {
			this.$fxEventBus.$on('getMsgNum', () => {
				this.getMsgNum()
			})
			if (window.sessionStorage.getItem('app') === 'scm8') {
				this.showAside = false
			}
			this.initUserAuthority()
			this.activeIndex = this.$route.meta && this.$route.meta.menuIndex
			this.getAuthority('07_0002_0000_00')
			this.getAuthority('07_0001_0000_00')
			this.getAuthority('')
			this.findShopList().then((data) => {
				if (data.length > 0) {
					this.shopOptions = data
					if (window.sessionStorage.getItem('organid')) {
						this.sellerShopId = window.sessionStorage.getItem('organid')
					} else {
						this.sellerShopId = data[0].organid
						window.sessionStorage.setItem('organid', this.sellerShopId)
					}
					this.getMessage()
				}
			})
			this.loop()
			this.printLoop()
			this.getHeadImg()
			this.getMsgNum()
			this.getShopList()
			this.guardtimerrun()
		},
		closeMini () {
			this.showMini = false
		},
		goOrder (item) {
			let a = item
			if (a.ordertype === 1) {
				if (a.billState === 0 && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === 1 && !this.AuthorityList['07_0002_0007_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === 2 && !this.AuthorityList['07_0002_0010_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === 3 && !this.AuthorityList['07_0002_0013_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				if (a.billState === 4 && !this.AuthorityList['07_0002_0001_00']) {
					this.$message.error('您没有查看该退货单的权限!')
					return false
				}
				a.refundid = a.refundorderid
				let b = JSON.stringify(a)
				window.sessionStorage.setItem('refundOrderParams', b)
				let shopid = ''
				this.shopOptions.forEach(e => {
					if (this.sellerShopId === e.organid) {
						shopid = e.shopId
					}
				})
				let refundTab = { orderStatus: a.billState, active: '', shopId: shopid }
				window.sessionStorage.setItem('refundTab', JSON.stringify(refundTab))
				window.sessionStorage.setItem('windowId', item.windowid)
				if (this.$route.path === '/main/refundOrderDetail') {
					this.$fxEventBus.$emit('reloadReturnOrder')
				} else {
					this.$router.push({ path: 'refundOrderDetail' })
				}
				item.readflag = true
			} else {
				if (a.billState === 0 && !this.AuthorityList['07_0001_0001_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 1 && !this.AuthorityList['07_0001_0004_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 2 && a.isSellerpull === 0 && !this.AuthorityList['07_0001_0007_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 2 && a.isSellerpull === 1 && !this.AuthorityList['07_0001_0010_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 3 && !this.AuthorityList['07_0001_0013_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 4 && !this.AuthorityList['07_0001_0016_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				if (a.billState === 5 && !this.AuthorityList['07_0001_0019_00']) {
					this.$message.error('您没有查看该订单的权限!')
					return false
				}
				let billState = ''
				switch (a.billState) {
				case 0:
					billState = '待付款'
					break
				case 1:
					billState = '待接单'
					break
				case 2:
					billState = a.isSellerpull === 1 ? '备货中' : '待发货'
					break
				case 3:
					billState = '待收货'
					break
				case 4:
					billState = '已完成'
					break
				case 5:
					billState = '已取消'
					break
				}
				this.orderParams.orderId = a.orderid
				this.orderParams.statusId = a.statusid
				this.orderParams.differ = a.differ
				this.orderParams.buypullstate = a.buypullstate
				this.orderParams.billState = billState
				this.orderParams.messageid = a.messageId
				let orderParams = JSON.stringify(this.orderParams)
				let aaa = { isSellerpull: a.isSellerpull === 1 }
				aaa.organid = this.sellerShopId
				let shopid = ''
				this.shopOptions.forEach(e => {
					if (this.sellerShopId === e.organid) {
						shopid = e.shopId
					}
				})
				aaa.sellerShopId = shopid
				window.sessionStorage.setItem('tabInfo', JSON.stringify(aaa))
				window.sessionStorage.setItem('orderInfo', orderParams)
				window.sessionStorage.setItem('windowId', item.windowid)
				if (this.$route.path === '/main/orderDetail') {
					this.$fxEventBus.$emit('reloadOrder')
				} else {
					this.$router.push('/main/orderDetail')
				}
				item.readflag = true
			}
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/selectOrganList`
			}).then(res => {
				this.shopList = res[0].shopInfoList
			})
		},
		shopChange (e) {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/defaultSellerShop/` + e
			}).then(res => {
				if (res.result) {
					window.sessionStorage.setItem('shiroSession', res.data.shiroSession)
					this.shopList.forEach(item => {
						if (e === item.id) {
							window.sessionStorage.setItem('organid', item.id)
							this.shopName = item.name
						}
					})
					if (this.$route.name === 'home') {
						window.location.hash = `#/main/home?session=${res.data.shiroSession}`
					}
					let pageName = ['editStorage', 'orderDetail', 'refundOrderDetail', 'afterSaleOrder']
					let pagePushName = ['storage', 'order', 'refundOrder', 'afterSale']
					let pageIndex = pageName.indexOf(this.$route.name)
					if (pageIndex !== -1) {
						this.$router.push('/main/' + pagePushName[pageIndex])
					} else {
						location.reload()
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getMsgNum () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindowsCount`,
				loading: false
			}).then(res => {
				if (res.result) {
					this.newMsgNum = res.data
				}
			})
		},
		readMsg1 (data) {
			let params = {
				windowId: data.windowid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindows/read`,
				data: params
			}).then(res => {
				if (res.result) {
					data.readflag = true
					this.getMsgNum()
				}
			})
		},
		readAllMsg () {
			let params = {
				windowId: null
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindows/read`,
				data: params
			}).then(res => {
				if (res.result) {
					this.hasMoreMsg = true
					this.getMsg()
				}
			})
		},
		hasNewMsg () {
			let params = {
				flashType: 0,
				limitWindowId: this.firstId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindows`,
				data: params
			}).then(res => {
				if (res.result) {
					let list = this.initList(res.data.list)
					this.firstId = list[0].windowid
					this.msgList1 = list.concat(this.msgList1)
					this.newMsgNum = res.data.count
				}
			})
		},
		loadMore () {
			this.isLoad = true
			let params = {
				flashType: 1,
				limitWindowId: this.lastId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindows`,
				data: params
			}).then(res => {
				if (res.result) {
					this.isLoad = false
					if (res.data.list.length === 0) {
						this.hasMoreMsg = false
						return false
					}
					let list = this.initList(res.data.list)
					this.lastId = list[list.length - 1].windowid
					this.hasMoreMsg = list.length === 5
					this.newMsgNum = res.data.count
					this.msgList1 = this.msgList1.concat(list)
				}
			})
		},
		onScroll (e) {
			let height = this.$refs.msgBox.scrollHeight - this.$refs.msgBox.scrollTop - this.$refs.msgBox.clientHeight
			if (height < 10 && !this.isLoad && this.hasMoreMsg) {
				this.loadMore()
			}
		},
		msgClick () {
			this.showMsg = !this.showMsg
			if (!this.showMsg) {
				return false
			}
			this.hasMoreMsg = true
			this.getMsg()
		},
		date0 (num) {
			if (+num < 10) {
				return '0' + num
			} else {
				return num
			}
		},
		initList (list) {
			list.forEach(item => {
				item.totalmoney = this.$fxUtils.toFixedSHW(item.totalmoney, 2)
				let day = item.createdate.split(' ')[0]
				let time = item.createdate.split(' ')[1]
				let date = new Date()
				let day1 = new Date()
				let day2 = new Date()
				day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
				day2.setTime(day2.getTime() - 2 * 24 * 60 * 60 * 1000)
				let today = date.getFullYear() + '-' + this.date0(date.getMonth() + 1) + '-' + this.date0(date.getDate())
				let yesterday = day1.getFullYear() + '-' + this.date0(day1.getMonth() + 1) + '-' + this.date0(day1.getDate())
				let beforeyesterday = day2.getFullYear() + '-' + this.date0(day2.getMonth() + 1) + '-' + this.date0(day2.getDate())
				if (day === today) {
					item.time = time
				}
				if (day === yesterday) {
					item.time = '昨天' + time
				}
				if (day === beforeyesterday) {
					item.time = '前天' + time
				}
				if (item.iscancel) {
					item.title = '订单申请取消'
				} else {
					if (item.ordertype === 1) {
						item.title = '订单申请退货'
					} else {
						if (item.orderstatus === 1) {
							item.title = '待接单订单'
						}
						if (item.orderstatus === 2) {
							if (item.pushstate === 3) {
								item.title = '备货中订单'
							} else {
								item.title = '待发货订单'
							}
						}
					}
				}
			})
			return list
		},
		getMsg () {
			let params = {
				flashType: null,
				limitWindowId: null
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/soundRemindWindows`,
				data: params
			}).then(res => {
				if (res.result) {
					this.newMsgNum = res.data.count
					if (res.data.list.length === 0) {
						this.hasMoreMsg = false
						return false
					}
					let list = this.initList(res.data.list)
					this.msgList1 = list
					this.firstId = list[0].windowid
					this.lastId = list[list.length - 1].windowid
					this.hasMoreMsg = list.length === 5
					if (!this.AuthorityList['12_0001_0000_00']) {
						this.msgList1 = []
					}
				}
			})
		},
		getHeadImg () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				this.headImg = res.imgurl
			})
		},
		stoptimer () {
			if (this.guardtimer === null) {
				this.guardtimerrun()
			} else {
				clearTimeout(this.guardtimer)
				this.guardtimer = null
			}
			if (this.timer2 !== null) {
				clearTimeout(this.timer2)
				this.timer2 = null
			}
			if (this.timer !== null) {
				clearTimeout(this.timer)
				this.timer = null
			}
		},
		guardtimerrun () {
			this.guardtimer = setTimeout(() => {
				this.guardtimercheck()
				this.guardtimerrun()
			}, 10000)
		},
		guardtimercheck () {
			let formData = new FormData()
			formData.append('time', 10000)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlCache}/queryflag`,
				data: formData,
				loading: false
			}).then(res => {
				if (res.keepflag) {
					if (res.autopringflag) {
						if (this.timer2 === null) {
							this.printLoop()
						}
					} else {
						clearTimeout(this.timer2)
						this.timer2 = null
					}
					if (res.remindflag) {
						if (this.timer === null) {
							this.loop()
						}
					} else {
						clearTimeout(this.timer)
						this.timer = null
					}
				} else {
					clearTimeout(this.timer2)
					this.timer2 = null
					clearTimeout(this.timer)
					this.timer = null
					clearTimeout(this.guardtimer)
					this.guardtimer = null
				}
			}).catch(() => {
				clearTimeout(this.timer2)
				this.timer2 = null
				clearTimeout(this.timer)
				this.timer = null
			})
		},
		loop () {
			this.timer = setTimeout(() => {
				this.check()
				this.loop()
			}, this.time)
		},
		check () {
			if (document.visibilityState === 'visible') {
				// let platFormName = window.sessionStorage.getItem('platFormName')
				document.title = `极速订卖家后台`
			}
			let formData = new FormData()
			formData.append('time', this.time)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlCache}/order/checkSoundRemindOrder`,
				data: formData,
				loading: false
			}).then(res => {
				this.time = 10000
				if (res.orderFlag) {
					let str = '您有一张新订单'
					document.title = str
					let sayhello = new window.SpeechSynthesisUtterance(str)
					window.speechSynthesis.speak(sayhello)
					// var url = 'http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&text=' + encodeURI(str)
					// var n = new Audio(url)
					// n.src = url
					// n.play()
				}
				if (res.windowFlag) {
					this.getMsgNum()
					if (this.showMsg) {
						this.hasNewMsg()
					}
				}
			})
		},
		printLoop () {
			this.timer2 = setTimeout(() => {
				this.printCheck()
				this.printLoop()
			}, this.time2)
		},
		printCheck () {
			let formData = new FormData()
			formData.append('time', this.time2)
			let _this = this
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlCache}/order/checkAutoPrintOrder`,
				data: formData,
				loading: false
			}).then(res => {
				this.time2 = 10000
				if (res.orderids) {
					this.getPrintDateBatch(res).then((res) => {
						if (!res) {
							return false
						}
						/* eslint-disable-next-line */
						let report = new FastReport()
						/* eslint-disable-next-line */
						let dsDate = eval(res)
						report.enable = true
						if (dsDate.length > 0) {
							let printDate = dsDate
							if (typeof (printDate) === 'undefined') {
								_this.$message.error('获取打印数据错误')
							} else {
								for (let i = 0; i < printDate.length; i++) {
									// 执行打印方法
									report.print(printDate[i])
									// 更新打印次数
									_this.updateFr3PrintCs(printDate[i].DS1[0].orderid)
								}
							}
						} else {
							_this.$message.error('获取打印数据错误')
						}
					})
				}
			})
		},
		getPrintDateBatch (res) {
			// 获取需要打印的单据的信息
			return new Promise((resolve, reject) => {
				let params = {
					orderids: res.orderids,
					templateid: res.printtemplateid,
					printer: res.printName
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/print/getAutoPrintOrderDate`,
					data: params
				}).then(res => {
					if (res.result) {
						resolve(res.data)
					}
				})
			})
		},
		updateFr3PrintCs (id) {
			let params = {
				orderid: id,
				templatetype: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/print/updateFr3PrintCs`,
				data: params
			})
		},
		changeShowMenu () {
			this.showMenu = !this.showMenu
		},
		exit () {
			this.$confirm('是否要退出？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				window.sessionStorage.removeItem('organid')
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlNVA}/logout`
				}).then(res => {
					window.sessionStorage.removeItem('shiroSession')
					window.sessionStorage.removeItem('valetSession')
					this.$message({
						message: '退出成功!',
						type: 'success',
						duration: 2000,
						onClose: () => {
							// document.cookie = 'username:' + ''
							this.$router.push({
								path: `/login`
							})
						}
					})
				})
			}).catch(() => {})
		},
		handleCommand1 (command) {
			if (command === 'helpCenter') {
				window.open('https://help.tcsl.com.cn/categoryList?categoryKey=5cb44a428d534e00979e61a7a75f7726', '_blank')
			} else if (command === 'showMini') {
				this.showMini = true
			} else if (command === 'dowmloadFile') {
				let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/%E6%9E%81%E9%80%9F%E8%AE%A22.0-%E5%8D%96%E5%AE%B6%E5%90%8E%E5%8F%B0%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.docx?timeStamp=' + new Date().getTime()
				window.location.href = url
			} else {
				let url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/biubiuorder/print/DeveicMgrSetup.exe'
				window.location.href = url
			}
		},
		handleCommand (command) {
			if (command === 'editPwd') {
				this.editePwdShow = true
			} else if (command === 'exit') {
				this.exit()
			}
		},
		closeEdit () {
			this.editePwdShow = false
		},
		loginUserInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIVA}/loginUserInfo`
			}).then(res => {
				this.name = res.name
				this.tel = res.tel
				this.shopName = res.sellerShopInfo.name
				this.shopNameId = res.sellerShopInfo.id
				window.localStorage.setItem('name', this.name)
				window.localStorage.setItem('shopName', this.shopName)
				window.localStorage.setItem('tel', this.tel)
				window.localStorage.setItem('syscodeid', res.syscodeid)
				this.$fxLogger.initSyscode({
					syscodeid: res.syscodeid,
					tel: this.tel,
					name: this.name
				})
				if (document.cookie) {
					this.username = document.cookie.split('ycg:')[1].slice(0, 11)
				} else {
					this.username = this.tel
				}
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						let shopId
						if (res.data.shop[0] !== '' && res.data.shop[0] !== null) {
							shopId = res.data.shop[0].shopId
							window.sessionStorage.setItem('shopId', JSON.stringify(shopId))
						}
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		getMessage () {
			this.msgList = []
			let params = {
				bsflag: 1,
				msgtype: 4
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/unread/get`,
				data: params
			}).then(res => {
				if (res.result === true) {
					res.data.bussinessMessage.forEach(element => {
						let len = element.message_alert.length
						element.msg = element.message_alert
						if (len > 50) {
							element.message_alert = element.message_alert.substring(0, 50) + '...'
						}
						this.$nextTick(() => {
							this.msgList.push(element)
						})
					})
				}
			})
		},
		cancelMsgDialog () {
			this.showMsgDialog = false
		},
		goDetail (item) {
			// console.log(item)
			this.message = item.msg
			this.readMsgId = item.message_id
			this.showMsgDialog = true
			// console.log(this.readMsgId)
		},
		haveRead () {
			let params = {
				id: this.readMsgId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/messagecenter/unread/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.loading = false
					this.start = 0
					this.total = 0
					this.msgList = []
					// this.$router.go(0)
					location.reload()
				}
			})
			this.showMsgDialog = false
		},
		initUserAuthority () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/initUserAuthority`
			}).then(res => {
				if (res.result === true) {
					this.loginUserInfo()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		}
	},
	beforeDestroy () {
		clearInterval(this.timer)
		this.timer = null
		clearInterval(this.timer2)
		this.timer2 = null
	}
}
</script>
<style lang="stylus" scoped>
.white-line{
	width: 1px;
	height: 59px;
	background-color: #FFFFFF;
}
.mini-img-box{
	width: 360px;
	height: 360px;
	background: #FFFFFF;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	img{
		width: 300px;
		height: 300px
	}
}
.msgTip{
	position:absolute;
	bottom: 60px;
	right:20px;
	z-index:999;
}
.tool-img {
	width: 50px;
	height: 50px;
	cursor: pointer;
	margin-bottom: 12px;
}
.tool-content {
	font-size: 12px;
	color: #333;
	&>div {
		height: 32px
		display: flex
		align-items: center
		cursor: pointer
		padding: 0 12px
		&:hover {
			background: #F5F7FA
		}
	}
	img {
		width: 16px;
		height: 16px;
		margin-right: 8px;
	}
}
.new-msg-num{
	position :absolute;
	bottom :40px;
	right:0px;
	padding: 0 4px;
    min-width: 16px;
    box-sizing: border-box;
	height:16px;
	font-size: 10px;
	display :flex;
	align-items :center;
	justify-content:center;
	background-color: #E50000;
	color :#fff;
	border-radius:8px
}
.msg-box{
	position:absolute;
	bottom:40px;
	z-index:999;
	right:80px;
	width:280px;
	height:310px;
	background-color:#FFFFFF;
	display:flex;
	flex-direction :column;
	border:1px solid var(--fx-primary-color)
}
.msg-box-title{
	width :100%;
	height :36px;
	background-color :var(--fx-primary-color);
	display :flex;
	align-items:center;
	color:#ffffff;
	padding:0 5px;
	justify-content :space-between;
	box-sizing:border-box;
}
.msg-box-body{
	flex :1;
	display :flex;
	overflow-y :auto;
	flex-direction :column;
}
.msg-box-body::-webkit-scrollbar {/*滚动条整体样式*/
	width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}
.msg-box-body::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	// background: #535353;

}
.msg-box-body::-webkit-scrollbar-track {/*滚动条里面轨道*/
	-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
	border-radius: 10px;
	background: #EDEDED;
}
.msg{
	box-sizing :border-box;
	width:100%;
	display :flex;
	flex-direction :column;
	padding :10px 10px 10px 16px;
}
.msg-title{
	display :flex;
	flex-direction :row;
	height :24px;
	font-size :13px;
	color :#333333;
	align-items :center;
	justify-content :space-between
}
.msg-body{
	color :#999999;
	font-size :13px;
	line-height :24px;
	text-align :left
}
.msg-btn-box{
	width :100%;
	margin-top: 10px;
	display:flex;
	flex-direction :row
}
.new-flage{
	position :relative
}
.new-flage::before{
	content :'';
	position:absolute;
	width 5px;
	height:5px;
	background-color :#FC4646;
	border-radius :50%;
	left:-8px;
	top:6px;
}
.msg-box-footer{
	cursor :pointer;
	width :100%;
	height :36px;
	background-color :#ffffff;
	display :flex;
	align-items:center;
	color:var(--fx-primary-color);
	border-top:1px solid var(--fx-primary-color);
	justify-content :center;
	box-sizing:border-box;
}
.index {
	width :100%;
	height:100%
	min-height :610px;
	.header {
		height: 51px!important;
		background: #fff;
		line-height: 51px;
		text-align: right;
		display:flex;
		padding: 0 16px
		// margin-bottom: 10px;
		// background: url('~images/img/head-bg.png') no-repeat;
		// background-size: 100% 100%;
		.title-box {
			width:100px;
			text-align:left;
			font-size:16px;
			color: #fff
			.fold-img {
				width: 20px;
				height: 20px;
				// margin-left: 20px;
				display: inline-block;
				margin-top: -3px;
				vertical-align: middle;
				cursor: pointer
			}
		}
		.menu-btn {
			display:flex;
			flex-direction:row;
			align-items:center;
			.btn{
				display:flex;
				flex-direction:row;
				align-items:center;
				justify-content:center;
			}
			.person-box {
				width: 100%;
				text-align: center;
				vertical-align: middle;
				cursor: pointer;
				display: inline-block;
				.el-dropdown-link {
					color: #333;
				}
				.shop-box {
					display: inline-block;
					// margin-right: 20px
					position: relative
					cursor: pointer
					color: #333
					font-size: 14px
					.shop-pull-box {
						position: absolute;
						top:0;
						left: 0;
						bottom: 0;
						right: 0;
						opacity: 0
					}
				}
			}
			.menu-btn-icon {
				width: 20px;
				height: 20px;
				vertical-align: middle;
				cursor: pointer;
				display:inline-block;
			}
			.unread-msg {
				position: relative;
				cursor: pointer;
			}
			.red-point {
				position: absolute;
				top: -2px;
				right: -2px;
				width: 6px;
				height: 6px;
				border-radius: 50%;
				background: red;
			}
			.message-btn, .exit-btn , .help-btn{
				margin-right:15px
			}
			.key-btn {
				width: 26px;
				height: 26px;
				margin-right:12px
			}
		}
		.system-message {
			flex:1;
			display: flex;
			align-items: center;
			height: 51px;
			overflow: hidden;
			padding-left: 30px;
			text-align: left;
			color: #333;
			.item-msg{
				list-style: none
				line-height: 30px
				height: 30px
				cursor: pointer
				margin-left: 50px
				&:nth-of-type(1) {
					margin-left: 0
				}
			}
		}
	}
	.container {
		height:100%;
		width :100%;
		.aside {
			background-color: #111F30
			overflow-y :auto;
			overflow-x :hidden
			.logo-box {
				// text-align: center
				// margin-top: 40px
				padding: 20px 18px
				display: flex
				align-items: center
				justify-content: center
				color: #DEEDEE
				font-size: 16px
				.logo-img {
					width: 80px;
					height: 80px;
					border-radius: 5px;
					display: inline-block
				}
				.logo-name {
					color:#fff;
					font-size:14px;
					margin-top:20px
				}
				.show-img{
					cursor: pointer;
					width:32px;
					height:32px;
					// margin-right: 8px;
					// float:left;
					// margin-top:12.5px;
					// margin-right:20px
					// border-radius: 6px;
				}
				.logo-text {
					margin-left: 6px
				}
			}
			.main-menu-style {
				// margin-top: 30px
				// max-width :132px
			}
		}
		.right-container {
			flex-direction: column;
			height : 100%;
			width: 100%;
			background: #F1F2F3
			.content {
				height : calc(100% - 65px)
				width: calc(100% - 32px)
				box-sizing: border-box
				margin: 16px;
				padding :0px 10px 0px 15px;
				background-color: #fff;
				border-radius: 4px;
			}
		}
	}
}
.detail-dialog-title {
	text-align: left
}
.msg-info {
	width: 85%
	line-height: 28px
	margin: 0 auto
	text-align: left
	padding-bottom: 35px;
}
.filings-content {
	padding: 20px 40px;
	text-align: center;
}
.filings-input {
	display: block;
	width: 350px;
	margin: 40px auto;
}
.filings-text {
	text-align: left;
	font-size: 15px;
	line-height: 24px;
}
</style>
<style lang="stylus">
.notice .el-dialog__title {
	padding-left 0
	border-left none
	font-weight bold
}
.help-center-dropdown{
	.el-dropdown-menu__item{
		display: flex
		align-items center
		color: #333 !important
	}
}
.miniDialog{
	.el-dialog{
		background-color: transparent !important;
		box-shadow :none !important;
	}
	.el-dialog__header{
		display: none
	}
}
.tool-class {
	padding: 6px 0
}
.fill-dialog {
	height: 0;
	.el-dialog__title {
		display: none;
	}
}
.fill-detail {
	position: absolute;
	top: 0;
	left: 0
	width: 800px;
	height: 634px;
	z-index: -1
}
</style>
